import { Link } from 'react-router-dom';
import SectionTitle from '@/components/feature/SectionTitle';
import { topics } from '@/mocks/topics';

export default function TopicsGrid() {
  return (
    <section className="bg-background-200/50">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-12">
        <SectionTitle
          icon="ri-bookmark-3-line"
          title="推荐专题"
          subtitle="聚焦当日赛事分析，成体系地读懂排名变化"
        />
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {topics.map((topic) => (
            <Link
              key={topic.id}
              to="/category/news"
              className="group relative rounded-lg overflow-hidden border border-background-200 cursor-pointer h-52"
            >
              <img
                src={topic.cover}
                alt={`${topic.title} 专题配图`}
                title={`${topic.title} - 51每日大赛专题`}
                className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary-950/90 via-primary-950/45 to-transparent"></div>
              <div className="relative h-full flex flex-col justify-end p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-2 py-0.5 rounded-full bg-accent-500 text-primary-950 text-xs font-bold whitespace-nowrap">
                    {topic.count} 篇
                  </span>
                  <span className="px-2 py-0.5 rounded-full bg-background-50/15 text-background-100 text-xs whitespace-nowrap backdrop-blur">
                    {topic.event}
                  </span>
                </div>
                <h3 className="text-lg font-black text-background-50">{topic.title}</h3>
                <p className="mt-1.5 text-sm text-background-200 leading-relaxed line-clamp-2">
                  {topic.description}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}